import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterSEO } from '../utils/seo'
import Home from '../views/Home.vue'
import Home1 from '../views/Home1.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Status from '../views/Status.vue'
import EmailVerification from '../views/EmailVerification.vue'
import PasswordForget from '../views/PasswordForget.vue'
import Navbar from '../components/TheNavbar.vue'
import Navbar1 from '../components/TheNavbar1.vue'
import Footer from '../components/TheFooter.vue'
import NotFound from '../components/The404Page.vue'
import Footer1 from '../components/Footer1.vue'
import Nav from '../components/Navbar.vue'
import Faq from '../views/Faq.vue'
import Event from '../views/Event.vue'
import Blog from '../views/Blog.vue'
import BlogDetail from '../views/BlogDetail.vue'
import EventDetail from '../views/EventDetail.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import Formations from '../views/Formations.vue'
import JobOffers from '../views/JobOffers.vue'
import JobOfferDetails from '../views/JobOfferDetails.vue'
import InvitationLanding from '../views/InvitationLanding.vue'

import TestsList from '../components/tests/TestsList.vue'

import TestCompleted from '../components/tests/TestCompleted.vue'
import UserProfile from '../views/UserProfile.vue'
import JobApplication from '../views/JobApplication.vue'
import ApplicationTests from '../views/ApplicationTests.vue'
import MyTestResults from '../views/MyTestResults.vue'

// Espace Client B2B
import TheClientNavbar from '../components/TheClientNavbar.vue'
import ClientDashboard from '../views/client/ClientDashboard.vue'
import ClientOffers from '../views/client/ClientOffers.vue'
import ClientOfferDetail from '../views/client/ClientOfferDetail.vue'
import ClientCandidateResults from '../views/client/ClientCandidateResults.vue'

const routes = [

  {
    path: '/',
    name: 'Home1',
    components: {
      navbar: Nav,
      main: Home1,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Accueil1'
    }
  },

  {
    path: '/home',
    name: 'Home',
    components: {
      navbar: Navbar,
      main: Home,
      footer: Footer1,
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Accueil'
    }
  },

  {
    path: '/status',
    name: 'Status',
    components: {
      navbar: Navbar,
      main: Status,
      footer: Footer1,
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Mon activité'
    }
  },
  
  {
    path: '/register',
    name: 'Register',
    components: {
      main: Register,
    },
    meta: {
      transition: 'fade'
    }
  },
  // {
  //   path: '/evaluation',
  //   name: 'evaluation',
  //   components: {
  //     navbar: Navbar,
  //     main: Evaluation,
  //     footer: Footer,
  //   },
  // },
  {
    path: '/login',
    name: 'Login',
    components: {
      main: Login,
    },
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/verify-email',
    name: 'EmailVerification',
    components: {
      main: EmailVerification,
    },
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/forget-password',
    name: 'PasswordForget',
    components: {
      main: PasswordForget,
    },
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/reset-password',
    name: 'PasswordReset',
    components: {
      main: () => import(/* webpackChunkName: "about" */ '../views/PasswordReset.vue'),
    },
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/cgu',
    name: 'CGU',
    components: {
      main: () => import(/* webpackChunkName: "about" */ '../views/CGU.vue'),
    },
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/new-candidacies',
    name: 'NewCandidacy',
    components: {
      navbar: Navbar1,
      main: () => import(/* webpackChunkName: "about" */ '../views/NewCandidacy.vue'),
      footer: Footer,
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Nouvelle candidature'
    }
  },
  {
    path: '/edit-candidacy',
    name: 'EditCandidacy',
    components: {
      navbar: () => import(/* webpackChunkName: "about" */ '../components/TheNavbar.vue'),
      main: () => import(/* webpackChunkName: "about" */ '../views/NewCandidacy.vue'),
      footer: () => import(/* webpackChunkName: "about" */ '../components/TheFooter.vue')
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Modifier ma candidature'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    components: {
      navbar: Navbar,
      main: UserProfile,
      footer: Footer1
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Mon profil'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    components: {
      navbar: Nav,
      main: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Nous contacter'
    }
  },
  {
    path: '/faq',
    name: 'Faq',
    components: {
      navbar: Nav,
      main: Faq,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'FAQ'
    }
  },
  {
    path: '/evenements',
    name: 'Event',
    components: {
      navbar: Nav,
      main: Event,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Évènement'
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    components: {
      navbar: Nav,
      main: Blog,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Évènement'
    }
  },
  {
    path: '/blog/:id/:slug',
    name: 'Article-detail',
    components: {
      navbar: Nav,
      main: BlogDetail,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Blog Détail'
    },
    props: true 
  },
  {
    path: '/evenement/:id/:slug',
    name: 'Event-detail',
    components: {
      navbar: Nav,
      main: EventDetail,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Evènement Détail'
    },
    props: true 
  },
  
  {
    path: '/about',
    name: 'About',
    components: {
      navbar: Nav,
      main: About,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'À propos'
    }
  },
  {
    path: '/services',
    name: 'Services',
    components: {
      navbar: Nav,
      main: Services,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Nos Services'
    }
  },
  {
    path: '/formations',
    name: 'Formations',
    components: {
      navbar: Nav,
      main: Formations,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Nos Formations'
    }
  },
  {
    path: '/job-offers',
    name: 'JobOffers',
    components: {
      navbar: Nav,
      main: JobOffers,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Offres d\'emploi'
    }
  },
  
  {
    path: '/job-offers/:id',
    name: 'JobOfferDetails',
    components: {
      navbar: Nav,
      main: JobOfferDetails,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Détails de l\'offre'
    }
  },
  {
    path: '/invite/:token',
    name: 'InvitationLanding',
    components: {
      navbar: Nav,
      main: InvitationLanding,
      footer: Footer
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Invitation'
    }
  },
  {
    path: "/:catchAll(.*)",
    name: 'Not-Found',
    components: {
      main: NotFound,
    }
  },
  {
    path: '/tests/:jobId',
    name: 'tests-list',
    components: {
      navbar: Navbar,
      main: TestsList,
      footer: Footer1
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Tests psychométriques'
    }
  },
  {
    path: '/test/:id',
    name: 'test-taking',
    components: {
      navbar: Navbar,
      main: () => import('../views/TestTaking.vue'),
      footer: Footer1
    },
    props: {
      main: true
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Test en cours'
    }
  },
  {
    path: '/test/:testId/completed',
    name: 'test-completed',
    components: {
      navbar: Navbar,
      main: TestCompleted,
      footer: Footer1
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Test terminé'
    }
  },
  {
    path: '/jobs/:id/apply',
    name: 'JobApplication',
    components: {
      navbar: Navbar,
      main: JobApplication,
      footer: Footer1
    },
    meta: {
      requiresAuth: false,
      frenchName: 'Postuler'
    }
  },
  {
    path: '/applications/:id/tests',
    name: 'application-tests',
    components: {
      navbar: Navbar,
      main: ApplicationTests,
      footer: Footer1
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Tests de candidature'
    }
  },
  {
    path: '/my-results/:applicationId',
    name: 'MyTestResults',
    components: {
      navbar: Navbar,
      main: MyTestResults,
      footer: Footer1
    },
    meta: {
      requiresAuth: true,
      frenchName: 'Mes résultats'
    }
  },

  // --- Espace Client B2B (role_id = 6) ---
  {
    path: '/client/dashboard',
    name: 'ClientDashboard',
    components: {
      navbar: TheClientNavbar,
      main: ClientDashboard,
    },
    meta: {
      requiresAuth: true,
      requiresClient: true,
      frenchName: 'Espace client - Tableau de bord'
    }
  },
  {
    path: '/client/offers',
    name: 'ClientOffers',
    components: {
      navbar: TheClientNavbar,
      main: ClientOffers,
    },
    meta: {
      requiresAuth: true,
      requiresClient: true,
      frenchName: 'Espace client - Mes offres'
    }
  },
  {
    path: '/client/offers/:id',
    name: 'ClientOfferDetail',
    components: {
      navbar: TheClientNavbar,
      main: ClientOfferDetail,
    },
    meta: {
      requiresAuth: true,
      requiresClient: true,
      frenchName: 'Espace client - Détail offre'
    }
  },
  {
    path: '/client/candidates/:applicationId',
    name: 'ClientCandidateResults',
    components: {
      navbar: TheClientNavbar,
      main: ClientCandidateResults,
    },
    meta: {
      requiresAuth: true,
      requiresClient: true,
      frenchName: 'Espace client - Résultats candidat'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 }
  },
})

setupRouterSEO(router)

export default router